module.exports = {
    lists: {
        myWoolworthsRewardsListPageHeading: 'Products I Purchased with my Woolworths Rewards Card',
        noPastShopsMessage: 'No past shop exists.',
        myListsShowMoreThreshold: 4,
        pastShopsShowMoreThreshold: 3,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/lists.js